import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { useDrawer } from 'ducks/drawers/hooks'
import selectCurrentUser from 'ducks/currentUser/selectors/selectCurrentUser'
import StartContent from 'components/StartContent'
import inbox from 'assets/inbox_empty.png'
import { CHANNEL_EMAIL_TYPES } from 'subapps/settings/components/drawers/Channels/Channels.data'
import { googleLogo as GoogleLogo } from 'assets/icons/groove'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import { doUpdateAccount } from 'actions/account'
import { selectShowDemoMailboxLink } from 'selectors/trial_setup'

import { styles } from './styles'

const EmptyPage = () => {
  const currentUser = useSelector(selectCurrentUser)
  const dispatch = useDispatch()

  const { openDrawer: openEmailDrawer } = useDrawer(
    CHANNEL_EMAIL_TYPES.forwarding.drawer
  )
  const { drawerId, openDrawer: openOAuthDrawer } = useDrawer(
    CHANNEL_EMAIL_TYPES.google.drawer
  )

  const showDemoLink = useSelector(selectShowDemoMailboxLink)

  const handleCreateEmail = useCallback(
    () => {
      openEmailDrawer('new', {
        additionalProps: {
          firstStep: true,
          drawerSource: 'inbox',
        },
      })
    },
    [openEmailDrawer]
  )

  const handleCreateOAuth = useCallback(
    () => {
      openOAuthDrawer('new', {
        query: {
          ...buildDrawerQueryParam(drawerId, 'drawerChannelType', 'google'),
        },
        additionalProps: {
          firstStep: true,
          drawerSource: 'inbox',
        },
      })
    },
    [openOAuthDrawer, drawerId]
  )

  const handleDemoInbox = useCallback(
    () => {
      dispatch(
        doUpdateAccount({ show_demo_mailbox: true }, { moduleOptions: {} })
      )
    },
    [dispatch]
  )

  const firstName = currentUser?.first_name

  return (
    <div css={styles.container}>
      <div css={styles.innerContainer}>
        <StartContent
          title={firstName ? `Welcome ${firstName}!` : 'Welcome!'}
          subtitle={`Let's get your emails flowing in by connecting your first ${app.t(
            'mailbox'
          )} to your Groove account.`}
          css={styles.content}
        >
          <div css={[text.styles.textSm, text.styles.fontSemibold]}>
            Setup time of 2 minutes or less
          </div>
          <div css={styles.btns}>
            <Button
              css={[styles.btn, styles.oAuthButtton]}
              type="info"
              size="xBig"
              onClick={handleCreateOAuth}
              customIcon={<GoogleLogo />}
            >
              Connect Gmail
            </Button>
            <Button
              type="tertiary"
              size="xBig"
              css={[styles.btn, styles.emailBtn]}
              onClick={handleCreateEmail}
            >
              Add email from another provider
            </Button>
          </div>
          {showDemoLink && (
            <p>
              Not ready to create your own yet?{' '}
              <button css={styles.demoLink} onClick={handleDemoInbox}>
                Check out a demo {app.t('mailbox')}
              </button>
            </p>
          )}
        </StartContent>
        <div css={styles.imgWrapper}>
          <img src={inbox} alt="Empty" />
        </div>
      </div>
    </div>
  )
}

export default EmptyPage
